import { financialHighlightsAsOfDateAtom } from "../../metrics.state";
import { useAtomValue } from "jotai";
import { InfoTooltip } from "../../components/InfoTooltip";
import { formatAsOfDate } from "../../utils/formatAsOfDate";
import { BalanceSheetSummary } from "./BalanceSheetSummary";
import { IncomeStatementSummary } from "./IncomeStatementSummary";

export function SummaryFinancials() {
    const asOfDate = useAtomValue(financialHighlightsAsOfDateAtom);
    const formattedAsOfDate = formatAsOfDate(asOfDate);

    return (
        <div className="space-y-8">
            <div className="body-s flex items-center gap-1">
                <span className="subdued italic">
                    Data as of {formattedAsOfDate}
                </span>
                <InfoTooltip>
                    The data displayed is from the last closed, complete
                    calendar period available in the company&apos;s accounting
                    system. Hum does not display partial period data.
                </InfoTooltip>
            </div>
            <IncomeStatementSummary />
            <BalanceSheetSummary />
        </div>
    );
}
